(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kiko-customisation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function(event) {
  const details = event.target;
  if (!details.matches?.('.kiko-custom-details') || !details.open) return;
  const panel = details.closest('[data-kiko-custom]');
  const productInfo = panel.closest('product-info');
  const id = productInfo?.querySelector('product-form input[name="id"]')?.value || new URL(window.location.href).searchParams.get('variant');
  const select = panel.querySelector('[data-kiko-variant]');
  if (select && id) {
    const option = Array.from(select.options).find(item => item.dataset.variantId === id);
    if (option) select.value = option.value;
  }
}, true);
function openKikoResult() {
  document.querySelectorAll('[data-kiko-result]').forEach(result => {
    const details = result.closest('details');
    if (details) details.open = true;
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openKikoResult);
else openKikoResult();
document.addEventListener('shopify:section:load', openKikoResult);
  } catch(e) { console.error(e); }
})();

})();
